import React, { Component } from 'react';
import { Button, Input, Spin, DatePicker, message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Sider from '../PlanSider';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';
import moment from 'moment';
import EditableCell from '../../basicElement/EditableCell';

class InvStart extends Component {
    state = {
        data: [],
        oldData: [],
        loading: false,
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        investigationPlanBeginTime: '',
        investigationPlanEndTime: '',
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationStageByInvId();
        this.queryInvDetail();
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { invState, siteId } = sessionStorage;
        const isConcrete = invState == 2;
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.queryInvestigationSiteStartPlan,
            data: { ...searchParams,
                curSiteId: isConcrete ? siteId : undefined,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    oldData: JSON.parse(JSON.stringify(datas)), // 用于取消时的回滚用
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleTableChange = params => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }


    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value || undefined;
        this.setState({ searchParams });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData({ offset: 1 });
        });
    };

    searchComponent = () => {
        const { siteId } = sessionStorage;
        if (siteId == 0) {
            const { searchParams: { invSiteCode, invSiteName } } = this.state;
            return (
                <div className="filter-bar">
                    <div className="form-item">
                        <label className="ui-label">中心编号</label>
                        <Input
                            value={invSiteCode}
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'invSiteCode')}
                        />
                    </div>
                    <div className="form-item">
                        <label className="ui-label">中心名称</label>
                        <Input
                            value={invSiteName}
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'invSiteName')}
                        />
                    </div>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                </div>
            );
        }
    }

    export = () => {
        const { searchParams } = this.state;
        const url = API_URL.plan.exportInvestigationSiteStartPlan;
        ExportUtil.export({ ...searchParams }, null, url);
    }

    queryInvDetail = () => {
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvDetail,
            data: {
                invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { investigationPlanBeginTime, investigationPlanEndTime } = res.investigation || {};
                this.setState({
                    investigationPlanBeginTime,
                    investigationPlanEndTime,
                });
            },
        };
        $.sendRequest(options);
    }

    isDateInRange = (dateToCheck) => {
        if (!dateToCheck) {
            return true
        }
        const { investigationPlanBeginTime, investigationPlanEndTime } = this.state;
        const startDate = moment(investigationPlanBeginTime);
        const endDate = moment(investigationPlanEndTime);
        return moment(dateToCheck).isBetween(startDate, endDate, 'day', '[]');
    };

    // edit table
    save = index => {
        const { data } = this.state;
        const target = data[index];
        const { planProjectDate, planSiteDate, investigationSiteId, siteIsCancel, siteIsCancelDefineOptionList = [] } = target;
        const siteIsCancelTrue = siteIsCancelDefineOptionList.find( el => siteIsCancel == el.ssuModuleStructureDefineOptionId).ssuModuleStructureDefineOptionName
        // if (!planProjectDate) {
        //     message.warning('请选择参与时间！');
        //     return;
        // }
        if (!planSiteDate && siteIsCancelTrue == '否' ) {
            message.warning('请选择计划site启动日期！');
            return;
        }
        
        
        // 中心关闭记录保存时需新增校验：项目计划开始时间≤关闭中心完成时间≤项目计划结束时间
        // 中心启动记录保存时需新增校验：项目计划开始时间≤计划site启动日期≤项目计划结束时间；项目计划开始时间≤计划递交立项资料日期≤项目计划结束时间；
        const isInSiteStartRange = this.isDateInRange(planSiteDate) && this.isDateInRange(planProjectDate);
        if (!isInSiteStartRange) {
            return message.warning('计划site启动日期或计划递交立项资料日期不在项目计划时间范围内');
        }
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.addInvestigationSiteStartPlan,
            data: {
                investigationSiteId,
                planProjectDate: format('date', planProjectDate),
                planSiteDate: format('date', planSiteDate),
                siteIsCancel,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                }, () => {
                    this.update(index, false);
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = callback => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { curRole, invState, investigationSiteName } = sessionStorage;
        const showOperator = curRole == 'PA' || curRole == 'PM' || (!investigationSiteName && curRole == 'CTA');
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            // sorter: true,
            width: 100,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            // sorter: true,
            width: 120,
        }, {
            title: '计划递交立项资料的日期',
            dataIndex: 'planProjectDate',
            key: 'planProjectDate',
            width: 200,
            render: (text, record, index) => {
                const { editable, planProjectDate } = record;
                if (editable) {
                    return (
                        <div style={{ display: 'inline-block' }}>
                            <DatePicker
                                style={{ width: 120 }}
                                value={planProjectDate ? moment(planProjectDate) : null}
                                placeholder="请选择"
                                onChange={(date, dateString) => this.handleDateChange(date, dateString, 'planProjectDate', index)}
                            />
                        </div>
                    );
                }
                return (
                    <span>
                        {format('date', planProjectDate)}
                    </span>
                );
            },
        }, {
            title: '计划site启动日期',
            dataIndex: 'planSiteDate',
            key: 'planSiteDate',
            width: 200,
            render: (text, record, index) => {
                const { editable, planSiteDate } = record;
                if (editable) {
                    return (
                        <div style={{ display: 'inline-block' }}>
                            <DatePicker
                                style={{ width: 120 }}
                                value={planSiteDate ? moment(planSiteDate) : null}
                                placeholder="请选择"
                                onChange={(date, dateString) => this.handleDateChange(date, dateString, 'planSiteDate', index)}
                            />
                        </div>
                    );
                }
                return (
                    <span>
                        {format('date', planSiteDate)}
                    </span>
                );
            },
        }, {
            title: '中心是否取消',
            dataIndex: 'siteIsCancel',
            key: 'siteIsCancel',
            width: 150,
            render: (text, record, index) => {
                const { editable, siteIsCancelDefineOptionList } = record;
                let value = text ? Number(text) : text;
                const options = (siteIsCancelDefineOptionList || []).map(i => {
                    if (!text && i.ssuModuleStructureDefineOptionName == '否') {
                        value = i.ssuModuleStructureDefineOptionId;
                        this.handleRadioChange(value, index, 'siteIsCancel')
                    }
                    return {
                        label: i.ssuModuleStructureDefineOptionName,
                        value: i.ssuModuleStructureDefineOptionId,
                    };
                });
                return (
                    <EditableCell
                        type="Radio"
                        editable={editable}
                        value={value}
                        config={{ options }}
                        onChange={value => this.handleRadioChange(value, index, 'siteIsCancel')}
                        style={{}}
                    />
                );
            },
        }];
        if (showOperator) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 80,
                render: (text, record, index) => {
                    const { editable, createType } = record;
                    return (
                        editable ?
                            <span>
                                <a onClick={() => this.save(index)}>保存</a>
                                <span className="ant-divider" />
                                <a onClick={() => this.update(index, false)}>取消</a>
                            </span>
                        : createType !== 'BeforeStart' ?
                            <a onClick={() => this.canEditByInvStatus(() => this.update(index, true))}>{ invState == '3' ? '设置' : '调整'}</a>
                        : '-'
                    );
                },
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = [...data];
        return dataSource;
    }

    update = (index, editable) => {
        this.setState(prevState => {
            prevState.data[index].editable = editable;
            if (!editable) {
                prevState.data[index] = prevState.oldData[index];
            }
            return prevState.data;
        });
    }

    handleDateChange = (date, dateString, key, index) => {
        this.setState(prevState => {
            prevState.data[index][key] = dateString;
            return prevState.data;
        });
    }

    handleRadioChange = (value, index, key) => {
        this.setState(prevState => {
            prevState.data[index][key] = value;
            return prevState.data;
        });
    }

    render() {
        const { loading, pagination, data } = this.state;
        const { invState } = sessionStorage;
        const isConcrete = invState == 2;
        return (
            <div className="content no_td_position">
                <Sider />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        <h2 className="title">{!isConcrete ? '各' : ''}中心启动计划</h2>
                    </div>
                    {this.searchComponent()}
                    <div style={{ padding: '10px 20px' }}>
                        <TableC
                            data={this.getDataSource()}
                            loading={loading}
                            columns={this.getColumns()}
                            rowKey="investigationSiteId"
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default InvStart;



// WEBPACK FOOTER //
// ./src/components/plan/siteStart/index.js